const FormStyles = {
    baseStyle: {
        formControl: {
            position: 'relative',
            sx: {
                'select[aria-invalid=true], input[aria-invalid=true]': {
                    borderColor: 'red.400',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 3px var(--chakra-colors-red-400)'
                    }
                },
                '& label[data-invalid]': {
                    color: 'red.400'
                }
            }
        },
        formLabel: {
            fontWeight: '300',
            fontFamily: 'body',
            fontSize: '16px',
            position: 'absolute',
            left: '15px',
            transition: 'all, 0.3s ease',
            color: 'black.100',
            zIndex: 1
        },
        inputGroup: {
            _hover: {
                '& input[aria-invalid="true"]': {
                    borderColor: 'red.400 !important'
                }
            }
        },
        inputField: {
            height: '56px',
            fontWeight: '300',
            fontFamily: 'body',
            lineHeight: '25px',
            letterSpacing: '0.08px',
            fontSize: '17px',
            color: 'black.100',
            backgroundColor: 'white',
            borderColor: 'gray.600',
            borderWidth: '1px',
            padding: 0,
            _placeholder: {
                fontWeight: '300',
                fontFamily: 'body',
                fontSize: '17px',
                color: 'gray.600'
            },
            _focusVisible: {
                borderColor: 'purple.300',
                borderWidth: '1px',
                borderBottomWidth: '2px',
                boxShadow: 'none',
                fontWeight: '500'
            },
            _hover: {
                borderColor: 'purple.300',
                boxShadow: 'none'
            },
            _focus: {
                borderColor: 'purple.300',
                borderWidth: '1px',
                borderBottomWidth: '2px',
                boxShadow: 'none',
                fontWeight: '500'
            }
        },
        selectIcon: {
            width: '13px !important',
            height: '13px !important'
        },
        selectField: {
            color: 'black.100',
            fontSize: '17px',
            fontFamily: 'body',
            fontWeight: 300,
            maxWidth: '201px',
            maxHeight: '43px',
            borderColor: 'gray.600',
            backgroundColor: 'white',
            _focusVisible: {
                borderColor: 'purple.300',
                borderBottomWidth: '2px',
                boxShadow: 'none',
                fontWeight: '500'
            },
            _focus: {
                borderColor: 'purple.300',
                borderBottomWidth: '2px',
                boxShadow: 'none',
                fontWeight: '500'
            },
            _hover: {
                borderColor: 'purple.300',
                boxShadow: 'none'
            }
        },
        errorMessage: {
            color: 'red.400',
            fontSize: '.875rem',
            fontWeight: '400'
        },
        fieldsStack: {
            spacing: '20px',
            sx: {
                '& input': {
                    padding: '16px 15px 6px',
                    borderRadius: '3px'
                }
            }
        }
    }
}

export default FormStyles
